import * as Yup from 'yup';
import { v4 as uuidv4 } from 'uuid';

export const giftCardSchema = Yup.object({
  giftCardNumber: Yup.string()
    .test('giftCard', 'Card number is not valid', (value) => {
      const noSpace = value.replaceAll(' ', '');

      return /^[0-9]+$/.test(noSpace) && noSpace.length === 17;
    })
    .required(),
  giftCardPin: Yup.string()
    .matches(/^[0-9]+$/)
    .length(4)
    .required(),
});

export const noSpace = (str) => str.replaceAll(' ', '');

export const getPaymentArgs = (
  paymentTypeId,
  recaptchaToken,
  redeemedGiftCards
) => {
  const existingCards = [...redeemedGiftCards];
  const lastCard = existingCards.pop();
  const result = {
    payment_type_id: paymentTypeId,
    uid: uuidv4(),
    amount_in_cents: lastCard.amount,
    gift_card_number: lastCard.cardNumber,
    gift_card_pin: lastCard.cardPin,
    recaptcha: recaptchaToken,
  };

  if (existingCards.length) {
    const additionalGiftCards = existingCards.map((item) => ({
      payment_type_id: paymentTypeId,
      uid: uuidv4(),
      gift_card_number: item.cardNumber,
      gift_card_pin: item.cardPin,
      amount_in_cents: item.amount,
    }));

    result.gift_cards = additionalGiftCards;
  }

  return result;
};

export const fetchReCapchaToken = () =>
  window.grecaptcha.execute(ecom.craftConfig.recaptchaSiteKey, {
    action: 'submit',
  });

export const getCheckoutArgs = (paymentTypeId, redeemedGiftCards) =>
  redeemedGiftCards.map((card) => ({
    payment_type_id: paymentTypeId,
    uid: uuidv4(),
    gift_card_number: card.cardNumber,
    gift_card_pin: card.cardPin,
    amount_in_cents: card.amount,
  }));
